import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageTemplate } from '@_widgets/common';

import { get, post } from '@_shared/config';
import { LeftChevronIcon } from '@_shared/icons';
import { Typography } from '@_shared/ui/Typography';
import * as S from './MarketingPage.style';

interface IABTestGoodsData {
	type: 'goods';
	thumbnailURL: string;
	URL: string;
	title: string;
	priceInfo: {
		finalPrice: string;
		discount: string;
	};
}

interface IABTestVideoData {
	type: 'video';
	thumbnailURL: string;
	URL: string;
	title: string;
}

type IABTestData = IABTestGoodsData | IABTestVideoData;

export function MarketingPage() {
	const { group } = useParams();
	const navigate = useNavigate();
	const [marketingData, setMarketingData] = useState<IABTestData | null>(null);

	useEffect(() => {
		post('/infra/ab-test/v1/log', {
			group,
			actionType: 'viewed_push',
		});
		get<IABTestData>(`/infra/ab-test/v1/${group}`).then((res) => {
			setMarketingData(res.data);
		});
	}, [group]);

	return (
		<PageTemplate
			nav={false}
			header={
				<S.Header>
					<S.BackIconWrapper
						onClick={() => {
							navigate('/');
						}}
					>
						<LeftChevronIcon />
					</S.BackIconWrapper>
				</S.Header>
			}
		>
			{marketingData && (
				<S.Container>
					<S.Contents>
						<img src={marketingData?.thumbnailURL} alt="thumbnail" />
						<S.TextContainer>
							<Typography type="headline-small" color="brown-primary" noOfLine={2}>
								{marketingData?.title}
							</Typography>
							{marketingData?.type === 'goods' && (
								<S.PriceWrapper>
									<Typography type="headline-small" color="orange-primary">
										{marketingData?.priceInfo.discount}
									</Typography>
									<Typography type="headline-small" color="brown-primary">
										{marketingData?.priceInfo.finalPrice}
									</Typography>
								</S.PriceWrapper>
							)}
						</S.TextContainer>
					</S.Contents>
					<S.ButtonWrapper>
						<button
							type="button"
							onClick={() => {
								post('/infra/ab-test/v1/log', {
									group,
									actionType: 'clicked_external',
								});
								window.location.href = marketingData.URL;
							}}
						>
							<Typography type="title-large" color="white-primary">
								웹 사이트로 이동 &gt;
							</Typography>
						</button>
					</S.ButtonWrapper>
				</S.Container>
			)}
		</PageTemplate>
	);
}
